import { useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * @typedef Props
 * @prop {string} [variant]
 */
/**
 * @param {Props} props
 */
const MotifTheme = ({ variant = 'light' }) => {
  const toggleTheme = () => {
    document.querySelector('body').setAttribute('motif-theme', variant);
    document.querySelector('body').setAttribute('class', `motif-theme-${variant}`);
  };

  useEffect(() => {
    toggleTheme();
  }, [variant]);

  return null;
};

MotifTheme.propTypes = {
  variant: PropTypes.string
};

export { MotifTheme };
